// extracted by mini-css-extract-plugin
export default {"login":"Login_login__4rE5+","loginform":"Login_loginform__vRHFt"};